import { render, staticRenderFns } from "./ListCbtQuestions.vue?vue&type=template&id=4edc6ddf"
import script from "./ListCbtQuestions.vue?vue&type=script&lang=js"
export * from "./ListCbtQuestions.vue?vue&type=script&lang=js"
import style0 from "./ListCbtQuestions.vue?vue&type=style&index=0&id=4edc6ddf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports